import { SafetyCertificateOutlined } from "@ant-design/icons";

import { Modal } from "../../../../shared";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import { formatString } from "../../../../../utils/constants/stringUtils";

function ResetMfaModal({
  isOpen,
  onConfirm,
  onCancel,
  staffName,
  isLoading = false,
}) {
  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      size="md"
      width={450}
      intent="destructive"
      closable={!isLoading}
      keyboard={!isLoading}
      maskClosable={!isLoading}
      destroyOnHidden
      data-testid="reset-mfa-modal"
      title={
        <span className="staff-details-reset-mfa-modal-title">
          <SafetyCertificateOutlined />
          {AppStrings.PAM_STAFF_RESET_MFA_TITLE}
        </span>
      }
      secondaryAction={{
        label: AppStrings.NO,
        onClick: onCancel,
        disabled: isLoading,
      }}
      primaryAction={{
        label: isLoading
          ? AppStrings.PAM_STAFF_RESET_MFA_RESETTING
          : AppStrings.PAM_STAFF_RESET_MFA_CONFIRM,
        onClick: onConfirm,
        loading: isLoading,
        disabled: isLoading,
      }}
    >
      <p>
        {formatString(AppStrings.PAM_STAFF_RESET_MFA_DESCRIPTION, {
          staffName,
        })}
      </p>
      <p>{AppStrings.PAM_STAFF_RESET_MFA_WARNING}</p>
    </Modal>
  );
}

export default ResetMfaModal;
